import { connect } from 'react-redux';
import Footer from './Footer';
import { getLocale, isEnabled } from '../../modules/translation/selectors';
import { changeLocale } from '../../modules/translation/actions';
const mapState = (state) => {
    return {
        locale: getLocale(state),
        hasTranslations: isEnabled(state)
    };
};
const mapDispatch = (dispatch) => ({
    onChange: (_, { value }) => dispatch(changeLocale(value))
});
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});
export default connect(mapState, mapDispatch, mergeProps)(Footer);
//# sourceMappingURL=Footer.container.js.map